import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import username from 'flarum/common/helpers/username';
export default class TwoFactorDisableConfirmModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }
  className() {
    return 'TwoFactorDisableConfirmModal Modal--small';
  }
  title() {
    return app.translator.trans('ianm-twofactor.forum.security.confirm_disable_2fa_title');
  }
  content() {
    var _app$session$user;
    const isSelf = ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) === this.attrs.user.id();
    const thisUser = this.attrs.user;
    return m("div", {
      className: "Modal-body"
    }, m("p", null, app.translator.trans(isSelf ? 'ianm-twofactor.forum.security.confirm_disable_2fa_text' : 'ianm-twofactor.forum.security.confirm_disable_2fa_text_other_user', {
      username: username(thisUser)
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--danger",
      onclick: this.disable.bind(this),
      loading: this.loading
    }, app.translator.trans('ianm-twofactor.forum.security.disable_2fa_button')), m(Button, {
      className: "Button Button--cancel",
      onclick: this.hide.bind(this)
    }, app.translator.trans('ianm-twofactor.forum.security.cancel_button'))));
  }
  disable() {
    this.loading = true;
    const userId = this.attrs.user.id();
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + "/users/".concat(userId, "/twofactor/disable")
    }).then(() => {
      this.loading = false;
      this.attrs.onDisabled();
      this.hide();
    }).catch(error => {
      // Handle any errors.
    });
  }
}
flarum.reg.add('ianm-twofactor', 'forum/components/TwoFactorDisableConfirmModal .tsxTwoFactorDisableConfirmModal ', TwoFactorDisableConfirmModal);